import { FC, useEffect } from 'react';

import { useGetBeamerUserDto } from 'app/services/beamer/hooks';
import { setPendoConfig } from 'app/services/pendo';
import { PropsWithOnlyChildren } from 'app/types';

// Component Definition
const PendoProvider: FC<PropsWithOnlyChildren> = props => {
  const beamerDto = useGetBeamerUserDto();

  useEffect(() => {
    setPendoConfig(beamerDto);
  }, [beamerDto]);

  return props.children;
};

export default PendoProvider;
